import store from '@/store'
import firebase from 'firebase'
import util from '@/util'
require('firebase/firestore')
const db = firebase.firestore()

db.collection('resource').onSnapshot((snap) => {
  let resources = Object.assign({}, store.state.resources)

  snap.docChanges.forEach((change) => {
    let data = change.doc.data()

    switch (change.type) {
      case 'removed':
        if (resources[data.key]) delete resources[data.key]
        break

      default:
        let categories = data.categories
        let index = Math.floor(Math.random() * categories.length)

        data.icon = `static/img/map/${categories[index]}.png`
        // @TODO do this on save and migrate so that we don't need to do this here!
        data.phoneLink = util.phoneLinkify(data.phone)

        resources[data.key] = data
    }
  })

  store.commit('setResources', resources)
  store.commit('filterResources')
  store.commit('toggleLoadingResources', false)

// @TODO Handle errors
}, (err) => {
  console.log(err)
})



// WEBPACK FOOTER //
// ./src/store/resource.js